import React from "react";
import { Card } from "../../components/Card";
import { ToolButton } from "../../components/ToolButton";
import { serializeAsJSON } from "../../data/json";
import { loadFirebaseStorage, saveFilesToFirebase } from "../data/firebase";
import { FileId, NonDeletedExcalidrawElement } from "../../element/types";
import { AppState, BinaryFileData, BinaryFiles } from "../../types";
import { nanoid } from "nanoid";
import { useI18n } from "../../i18n";
import { excalidrawPlusIcon } from "./icons";
import { encryptData, generateEncryptionKey } from "../../data/encryption";
import { isInitializedImageElement } from "../../element/typeChecks";
import { FILE_UPLOAD_MAX_BYTES } from "../app_constants";
import { encodeFilesForUpload } from "../data/FileManager";
import { MIME_TYPES } from "../../constants";
import { trackEvent } from "../../analytics";
import { getFrame } from "../../utils";
import { intializeTokenClient, initCodeClient, initTokenClient, uploadToDrive, createFolder, getFolder } from '../../data/upload_drive';
import {config} from "./../../../src/data/config"

// declare var google: any;
// declare var gapi: any;




export const exportToExcalidrawPlus = async (
  elements: readonly NonDeletedExcalidrawElement[],
  appState: Partial<AppState>,
  files: BinaryFiles,
) => {
  const firebase = await loadFirebaseStorage();

  const id = `${nanoid(12)}`;

  const encryptionKey = (await generateEncryptionKey())!;
  const encryptedData = await encryptData(
    encryptionKey,
    serializeAsJSON(elements, appState, files, "database"),
  );

  const blob = new Blob(
    [encryptedData.iv, new Uint8Array(encryptedData.encryptedBuffer)],
    {
      type: MIME_TYPES.binary,
    },
  );

  await firebase
    .storage()
    .ref(`/migrations/scenes/${id}`)
    .put(blob, {
      customMetadata: {
        data: JSON.stringify({ version: 2, name: appState.name }),
        created: Date.now().toString(),
      },
    });

  const filesMap = new Map<FileId, BinaryFileData>();
  for (const element of elements) {
    if (isInitializedImageElement(element) && files[element.fileId]) {
      filesMap.set(element.fileId, files[element.fileId]);
    }
  }

 

  if (filesMap.size) {
    const filesToUpload = await encodeFilesForUpload({
      files: filesMap,
      encryptionKey,
      maxBytes: FILE_UPLOAD_MAX_BYTES,
    });

    await saveFilesToFirebase({
      prefix: `/migrations/files/scenes/${id}`,
      files: filesToUpload,
    });
  }

  window.open(
    `https://plus.excalidraw.com/import?excalidraw=${id},${encryptionKey}`,
  );
};
// 随机字符串
function randomString(len:any) {
  len = len || 32;
  var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  var maxPos = $chars.length;
  var pwd = '';
  for (let i = 0; i < len; i++) {
      pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

async function getFolderId(token:any) {
  const res = await getFolder(token);
  console.log('getFolder', res);
  if (res.files && res.files.length) {
    return res.files[0].id;
  }
  const folder = await createFolder(token);
  console.log('createFolder', folder);
  return folder.id;
}

export const ExportToExcalidrawPlus: React.FC<{
  elements: readonly NonDeletedExcalidrawElement[];
  appState: Partial<AppState>;
  files: BinaryFiles;
  onError: (error: Error) => void;
}> = ({ elements, appState, files, onError }) => {
  const { t } = useI18n();
  let isLoading=false
  return (
    <Card color="primary">
      <div className="Card-icon">{excalidrawPlusIcon}</div>
      <h2>Google Drive</h2>
      <div className="Card-details">
        {/* {t("exportDialog.excalidrawplus_description")} */}
        Save the canvas to your Google Drive.
      </div>
      <ToolButton
        className="Card-button"
        type="button"
        // title={t("exportDialog.excalidrawplus_button")}
        isLoading={false}
        title="Save the canvas to your Google Drive."
        // aria-label={t("exportDialog.excalidrawplus_button")}
        aria-label="Save to drive"
        showAriaLabel={true}
        onClick={async () => {
          isLoading=true
          try {
            // 存到drive lsl
            let excalidraw=localStorage.getItem("excalidraw")
            console.log(excalidraw)
            // 将 JSON 对象转换为 JSON 字符串
            const jsonString = JSON.stringify(excalidraw);
            // 创建 Blob 对象
            const blob = new Blob([jsonString], { type: 'application/json' });
            //  后面开启一个loading
            const res:any = await initTokenClient();
            console.log(res,"res看看这个日志")
            let token = null;
            console.log(res,"res看看这个日志")
            if (res.access_token) {
              token = res.access_token;
            } else if (true) {
              // token = gapi.auth.getToken().access_token;
            }
            console.log('token', token);
            const parent_id = await getFolderId(token);
            console.log('parent_id', parent_id);
            const fileMetadata = {
              name: `${randomString(8)}.excalidraw`,
              mimeType: 'application/json',
              parents: [parent_id], // Assuming you want to create the file in the root folder, change this to the desired parent folder ID if needed
            };
            const upload_res = await uploadToDrive(fileMetadata, blob, token);
              
            console.log('uploadToDrive', upload_res);
            // 下面是之前 源码
            // trackEvent("export", "eplus", `ui (${getFrame()})`);
            // await exportToExcalidrawPlus(elements, appState, files);
          } catch (error: any) {
            console.error(error);
            isLoading=false
            if (error.name !== "AbortError") {
              onError(new Error(t("exportDialog.excalidrawplus_exportError")));
            }
          }
        }}
      />
    </Card>
  );
};
